import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel, StateModel } from "@insite/client-framework/Types/ApiModels";

export interface AddressValidationParameter {
    address1: string;
    address2: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
}

export interface ApiDataValue extends BaseModel {
    address1: string;
    address2: string | any;
    address3: string;
    components: Components;
    analysis: Analysis;
}

export interface Components extends BaseModel {
    administrative_area: string;
    country_iso_3: string;
    dependent_locality: string;
    locality: string;
    postal_code: string;
    postal_code_short: string;
    premise: string;
    premise_number: string;
    thoroughfare: string;
    thoroughfare_name: string;
    thoroughfare_type: string;
}

export interface Analysis extends BaseModel {
    address_precision: string;
    verification_status: string;
}

const addressValidationUri = "/api/v1/addressValidation";

export async function applyAddressValidation(
    addressValidationParameter: AddressValidationParameter,
): Promise<ServiceResult<ApiDataValue[]>> {
    try {
        const data = await post<AddressValidationParameter, ApiDataValue[]>(
            `${addressValidationUri}`,
            addressValidationParameter,
        );
        return {
            successful: true,
            result: data,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
